// src/components/ImageBox.jsx
import React from 'react';

const ImageBox = ({ src, alt = 'Image', width = 'w-64', border = true, className = '', }) => (
  <div className={` mb-6 ${className}`}>
    <img
      src={src}
      alt={alt}
      className={`${width} h-auto ${border ? 'border-2 border-purple-500 p-2 rounded-md' : ''}`}
    />
  </div>
);

export default ImageBox;
